import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import {
  SummaryReport,
  SummaryReportSelectedReviewersPATCH,
} from 'schemas/SummaryReport.schema';
import { apiFetch } from 'utils/apiUtils';

interface SelectReviewersSummaryReportVariables {
  teamId: string;
  campaignId: string;
  iterationId: string;
  batchId: string;
  summaryReportPatch: SummaryReportSelectedReviewersPATCH
}

export default function usePatchReportSelectedReviewers() {
  const { tokens } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['summary_report', 'campaign'],
    mutationFn: async ({
      teamId,
      campaignId,
      iterationId,
      batchId,
      summaryReportPatch,
    }: SelectReviewersSummaryReportVariables) => apiFetch<SummaryReport>({
      path: `team/${teamId}/campaign/${campaignId}/iteration/${iterationId}/summary_report/${batchId}/selected_reviewers`,
      method: 'PATCH',
      accessToken: String(tokens.accessToken),
      body: summaryReportPatch,
    }),
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['campaign'] });
      queryClient.refetchQueries({ queryKey: ['summary_report'] });
    },
  });
}
